import { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ChevronRight } from 'ts-react-feather-icons';

import HomeLayout from 'layouts/home-layout';

import EstateActions from './components/estate-actions';

const useStyles = makeStyles(() => ({
  container: {
    padding: '5%',
    flexGrow: 1,
  },
  title: {
    fontWeight: 600,
  },
  routeIconContainer: {
    verticalAlign: 'middle',
  },
}));

const SuperAdminEstates = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <HomeLayout showPortalName={false}>
      <div className={classes.container}>
        <div style={{ display: 'flex', verticalAlign: 'bottom' }}>
          <Typography className={classes.title} variant="h5" style={{ flex: 3 }}>
            <span
              onClick={() => {
                history.push(`/home`);
              }}
            >
              <span className={classes.routeIconContainer}>
                <img src="/home-icon.svg" alt="home-icon" />
              </span>
              <span className={classes.routeIconContainer}>
                <ChevronRight />
              </span>
            </span>
            Trusuite Queue
          </Typography>
        </div>
        <Grid container spacing={2}>
          <Grid item md={12} xs={12}>
            <EstateActions />
          </Grid>
        </Grid>
      </div>
    </HomeLayout>
  );
};

export default memo(SuperAdminEstates);
